module.exports = {"210104002":"大北街道","210104003":"万泉街道","210104006":"文官街道","210104007":"二台子街道","210104008":"津桥街道","210104009":"东站街道","210104012":"长安街道","210104015":"东塔街道","210104017":"上园街道","210104018":"前进街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210104.json
// module id = 590
// module chunks = 0